
import { requireAuth } from '@/api/auth'

export function getUser() {
    requireAuth();
    return {
        userId: localStorage.getItem('userId'),
        username: localStorage.getItem('username'),
        email: localStorage.getItem('email'),
    }
}